/**
 * Every enum the Community surface puts on the wire, as string values.
 *
 * One file rather than one per area because the vocabularies cross areas: ReactionType is read by
 * reactions, discussions and release notes, OrderDirection by both boards, and SlackAudience belongs to
 * jobs rather than to slack. Per-area placement would file SlackAudience in the one area that never uses it.
 */

export enum NoteAudience {
  Internal = 'Internal',
  External = 'External',
}

export enum ReactionType {
  ThumbUp = 'ThumbUp',
  ThumbDown = 'ThumbDown',
  Heart = 'Heart',
  Celebration = 'Celebration',
}

export enum OrderDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export enum FeatureRequestStage {
  Open = 'Open',
  Planned = 'Planned',
  InProgress = 'InProgress',
  Shipped = 'Shipped',
  Declined = 'Declined',
}

export enum FeatureRequestSort {
  Votes = 'Votes',
  CreatedAt = 'CreatedAt',
}

export enum FeatureRequestSystemAction {
  StageChanged = 'StageChanged',
  WorkItemLinked = 'WorkItemLinked',
  WorkItemUnlinked = 'WorkItemUnlinked',
  Edited = 'Edited',
}

export enum DiscussionSort {
  CreatedAt = 'CreatedAt',
  Replies = 'Replies',
  Reactions = 'Reactions',
}

export enum NotificationType {
  DiscussionReply = 'DiscussionReply',
  DiscussionReactionPost = 'DiscussionReactionPost',
  DiscussionReactionReply = 'DiscussionReactionReply',
  FeatureRequestVote = 'FeatureRequestVote',
  FeatureRequestComment = 'FeatureRequestComment',
  ReleasePublished = 'ReleasePublished',
}

export enum JobType {
  AdoImport = 'AdoImport',
  AiRewrite = 'AiRewrite',
  ReleaseSummary = 'ReleaseSummary',
  SlackPublish = 'SlackPublish',
}

export enum JobStatus {
  Queued = 'Queued',
  Running = 'Running',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
}

export enum SlackAudience {
  External = 'External',
  Internal = 'Internal',
  InternalOnly = 'InternalOnly',
}

export enum CategorizationSource {
  Rule = 'Rule',
  Ai = 'Ai',
}

/** Dropdown values, in the order a picker should offer them. */
export const FEATURE_REQUEST_STAGES: readonly FeatureRequestStage[] = [
  FeatureRequestStage.Open,
  FeatureRequestStage.Planned,
  FeatureRequestStage.InProgress,
  FeatureRequestStage.Shipped,
  FeatureRequestStage.Declined,
];

export const REACTION_TYPES: readonly ReactionType[] = [
  ReactionType.ThumbUp,
  ReactionType.ThumbDown,
  ReactionType.Heart,
  ReactionType.Celebration,
];

export const NOTE_AUDIENCES: readonly NoteAudience[] = [NoteAudience.External, NoteAudience.Internal];

export const SLACK_AUDIENCES: readonly SlackAudience[] = [
  SlackAudience.External,
  SlackAudience.Internal,
  SlackAudience.InternalOnly,
];

/** A job in one of these states will never change again, so a poller can stop. */
export const TERMINAL_JOB_STATUSES: readonly JobStatus[] = [JobStatus.Succeeded, JobStatus.Failed];

/**
 * FeatureRequestEditedFields is deliberately absent. It is a [Flags] enum rendered by ToString(), so the
 * wire value for an Edited entry is a list such as "Title, Description". An enum here would invite an
 * equality check that only matches when exactly one field changed.
 */
